import Vue from 'vue';

const useHttp = () => {
    return {
        http: Vue.http
    };
};

export default useHttp;
